/* eslint-disable react/destructuring-assignment */
import React from 'react';
import {
	Button, Form, Col, Row,
	Jumbotron
} from 'react-bootstrap';

import SweetAlert from 'sweetalert-react';

import AjaxHelper from '../common/AjaxHelper';
import TranslationHelper from '../common/TranslationHelper';
import UIHelper from '../common/UIHelper';

import '../css/resetPassword.css';
import '../../node_modules/sweetalert/dist/sweetalert.css';

export default class ResetPassword extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			pass: '',
			confirmPass: '',
			showErrorMsg: false
		};

		this.submit = this.submit.bind(this);
		this.passChange = this.passChange.bind(this);
		this.passMatched = this.passMatched.bind(this);
	}

	submit(e) {
		e.preventDefault();

		const token = new URLSearchParams(this.props.location.search).get('token');
		const data = { password: this.state.pass };

		if (this.state.pass !== this.state.confirmPass) {
			this.setState({ showErrorMsg: true });
		} else {
			AjaxHelper.invokeServerAPI(`/api/resetPassword?token=${token}`, data, (err) => {
				if (err) {
					UIHelper.showErrorMessage(`ERROR:${err.message}`);
				} else {
					UIHelper.showInfoMessage('Password changed.');
					setTimeout(() => {
						window.location.assign('/');
					}, 2000);
				}
			});
		}
	}

	passChange(e) {
		const param = {};
		param[e.target.name] = e.target.value;
		this.setState({ ...param });
	}

	passMatched() {
		if (!this.state.pass && !this.state.confirmPass) {
			return null;
		}
		if (this.state.pass === this.state.confirmPass) {
			return 'success';
		}

		return 'error';
	}

	render() {
		return (

			<div id="resetPassword" className="loginbackground" style={{ textAlign: 'left' }}>
				<SweetAlert
					show={this.state.showErrorMsg}
					title="Passwords does not match"
					text="Please make sure that both the passwords match"
					onConfirm={() => { this.setState({ showErrorMsg: false }); }}
				/>
				<Jumbotron className="messageBlock">
					<Form
						id="resetPwdForm"
						validated
						className="resetPasswordContent col-xs-12"
						onSubmit={(e) => this.submit(e)}
					>
						<Form.Group as={Row} controlId="pass" className="col-xs-12 m-5">
							<Form.Label column sm="4">
								{TranslationHelper.getValue('customer_account.resetPassword.new')}
							</Form.Label>

							<Col sm="8">
								<Form.Control
									type="password"
									name="pass"
									required
									onChange={(e) => this.passChange(e)}
								/>
							</Col>
						</Form.Group>

						<Form.Group as={Row} controlId="confirmPass" className="col-xs-12 m-5">
							<Form.Label column sm="4">
								{TranslationHelper.getValue('customer_account.resetPassword.confirm')}
							</Form.Label>
							<Col sm={8}>
								<Form.Control
									type="password"
									name="confirmPass"
									required
									onChange={(e) => this.passChange(e)}
								/>
							</Col>
						</Form.Group>

						<Form.Group as={Row} style={{ textAlign: 'center' }}>
							<Col sm={12}>
								<Button style={{ marginTop: '30px' }} type="submit" variant="primary">
									{TranslationHelper.getValue('customer_account.resetPassword.button')}
								</Button>
							</Col>
						</Form.Group>
					</Form>
				</Jumbotron>
			</div>
		);
	}
}
